import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { SetupTab } from 'areas/shared/pages/setup';
import { Switch } from 'fw/forms';
import { Label, ActionButton } from 'fw/components';
import * as API from 'modules/app/API';
import * as App from 'modules/app/App';
import { CommentsGrid } from 'areas/shared/components';
import ReviewPanel from 'areas/admin/certification/shared/ReviewPanel'
import AppReviewToolbar from 'areas/admin/certification/shared/AppReviewToolbar';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import * as ReportManager from 'modules/reports/ReportManager';

class Tour extends SetupTab {
    initialForm() {
        return {
            rowVersion: null,
            reviewComment: ''
        }
    }

    privileges() {
        return {
            add: App.hasPrivilege('AdminSiteReviewAccess'),
            edit: App.hasPrivilege('AdminSiteReviewAccess')
        }
    }

    urls() {
        return {
            get: API.Admin.url('/siteReview/getTourInfo'),
            save: API.Admin.url('/siteReview/saveTourInfo')
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
        }
    }

    saveRequest() {
        return {
            siteReviewTourId: this.state.form.siteReviewTourId,
            certificationId: this.state.form.certificationId,
            certificationKey: this.props.selectedId,
            compatibleOffices: this.state.form.compatibleOffices,
            compatibleEquipmentForBusinessType: this.state.form.compatibleEquipmentForBusinessType,
            equipmentAndFacilityKnowledge: this.state.form.equipmentAndFacilityKnowledge,
            businessLicenceRequired: this.state.form.businessLicenceRequired,
            rowVersion: this.state.form.rowVersion,
            reviewStatus: this.state.form.reviewStatus,
            reviewComment: this.state.reviewComment
        }
    }

    updatePostData = (form, dirty) => {
        this.setState({ form })

        if (dirty === true) this.dirt()
    }

    beforeSave = (cb) => {
        this._ast.checkReviewStatus(cb);
    }

    ready = () => {
        // If slected form is paper -> Redirect to FinalRecomm
        if (this.state.form.isPaperForm)
            window.location.href = `/admin/siteReview/${this.props.selectedId}/finalRecomm/${this.props.queueTypeCode}`;
    }

    handleReviewStatus = (formReview) => {
        let form = this.state.form;
        form.reviewStatus = formReview.isReviewCompleted;

        this.updatePostData(form, true);
    };

    handleStepCommentSave = (formParam, callback) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        if (callback)
            callback();
        else
            this.handleSubmit();
    }

    handleAdminStepToolbar = () => {
        this.handleSubmit();
    }

    handleAppReviewToolbar = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: "SiteReviewTourReport",
            format: "PDF",
            parameters: {
                CertificationId: this.state.form.certificationId
            }
        });

        ReportManager.execute(rq);
    };

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    isValidated(data) {
        return data.isSubmitted;
    }

    afterSave = (entityId, data) => {
        this.addCommentFromSave(data.reviewComment);
    }

    addCommentFromSave = (comment) =>{
        if (comment === null) 
            return;
           
        let comments = this.state.form.comments;
                
        comments.unshift({
            commentId: comment.commentId,
            reviewTypeDescription: comment.reviewTypeDescription,
            queueTypeDescription: comment.queueTypeDescription,
            content: comment.content,
            addedDate: comment.addedAt,
            addedBy: comment.addedBy,
            commentTypeCode: comment.commentTypeCode
        });

        let form = {
            ...this.state.form,
            comments
        };

        this.updatePostData(form, false);

        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });

    }

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onCommentSave={this.handleStepCommentSave}
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'STF'}
                queueTypeCode={'STR'}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={2}>
                        {this.state.form.showReview ?
                            <AppReviewToolbar
                                reviewTypeCode={'STF'}
                                queueTypeCode={'STR'}
                                comments={this.state.form.comments}
                                onFlagSave={this.handleAppReviewToolbar}
                                certificationKey={this.props.selectedId} />
                            : null}
                    </Col>
                    <Col md={4}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <h3>
                            {this.state.form.siteReviewTitle}
                            {this.renderAdminStepToolbar()}
                            <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print" bsSize="sm">Print</ActionButton></div>
                        </h3>
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label htmlFor="compatibleOffices">Are the Offices compatible with the description the Applicant gave of the Business?</Label>
                                    <Switch name="compatibleOffices" labelLeft="No" labelRight="Yes" bsStyle="success" />
                                </FormGroup>
                                <FormGroup>
                                    <Label htmlFor="compatibleEquipmentForBusinessType">Are the Offices/Equipment compatible with the type of Business the Applicant runs?</Label>
                                    <Switch name="compatibleEquipmentForBusinessType" labelLeft="No" labelRight="Yes" bsStyle="success" />
                                </FormGroup>
                                <FormGroup>
                                    <Label htmlFor="equipmentAndFacilityKnowledge">Does the Applicant exhibit knowledge of the Equipment and Facility?</Label>
                                    <Switch name="equipmentAndFacilityKnowledge" labelLeft="No" labelRight="Yes" bsStyle="success" />
                                </FormGroup>
                                <FormGroup>
                                    <Label htmlFor="businessLicenceRequired">Does the Company require a Business License?</Label>
                                    <Switch name="businessLicenceRequired" labelLeft="No" labelRight="Yes" bsStyle="success" />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <hr />
                            </Col>
                        </Row>

                    </Col>
                </Row>
                <Row>
                    <CommentsGrid
                        ref={(c) => { this._commentsGrid = c }}
                        comments={this.state.form.comments}
                        documents={this.state.form.reviewDocuments}
                        certificationKey={this.props.selectedId}
                        reviewTypeCode={"STF"}
                        queueTypeCode={"STR"}
                        enableExport={true}
                        entityId={this.state.form.entityId}
                        readonly={!this.state.privileges.edit || !this.state.enabled}
                        onSave={this.handleCommentsGrid}
                        onCommentChange={this.handleCommentChange} />
                </Row>
                {this.state.form.showComplete ?
                    <Row>
                        <ReviewPanel stepName="Tour of Facility" onChange={this.handleReviewStatus} reviewStatus={this.state.form.reviewStatus} />
                    </Row>
                : null}
            </React.Fragment>
        )
    }
}

export default Tour;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/siteReview/siteReviewInfo/tour/Tour.js